import icon from "../Geomatchry Icon-Newest.png";

// React imports
import { useState } from "react";
import { addEmailToList } from '../emailSignup';

import "./HomePage.css";

function HomePage() {
  const [userEmail, setUserEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (event) => {
    setUserEmail(event.target.value);
  };

  const submitPressed = async (event) => {
    event.preventDefault();

    const result = await addEmailToList(userEmail);
    setSuccessMessage(result.message);

    if (result.success) {
      setUserEmail("");
    }
  };

  return (
    <div className="Home-content">
      <div className="glass-card">
        {/* App Icon */}
        <div className="app-icon">
          <img src={icon} alt="Geomatchry Icon" />
        </div>

        {/* Title */}
        <h1 className="App-title">Geomatchry</h1>

        {/* Subtitle */}
        <p className="subtitle">The dating app to end all dating apps.</p>

        {/* Email Form */}
        <form onSubmit={submitPressed} className="email-form">
          <div className="input-span">
            <input
              type="email"
              className="user-text-input"
              placeholder="Your email here..."
              value={userEmail}
              onChange={handleChange}
            />
            <button type="submit" className="user-button">
              Join
            </button>
          </div>
        </form>

        {/* Success/Error Message */}
        {successMessage && (
          <div className="message-display">{successMessage}</div>
        )}

        {/* Launch Date */}
        <p className="launch-date">
          Coming to select colleges on September 3rd.
        </p>

        {/* Social Links */}
        <div className="social-links">
          <a
            href="https://www.instagram.com/geomatchry/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram
          </a>
          <span className="divider">|</span>
          <a
            href="https://www.tiktok.com/@geomatchry"
            target="_blank"
            rel="noopener noreferrer"
          >
            TikTok
          </a>
          <span className="divider">|</span>
          <span className="email-link">support@geomatchry.com</span>
        </div>
      </div>

      {/* Legal Links - Outside the glass card */}
      <div className="legal-links">
        <a href="/terms">Terms of Service</a>
        <span className="divider">|</span>
        <a href="/privacy">Privacy Policy</a>
      </div>
    </div>
  );
}

export default HomePage;
